import React from 'react';
import ReactDOM from 'react-dom';
import ContestLanding from '../common/ContestLanding';
import HmAjax from '../../util/HmAjax';
import ContestTopicComponent from '../plp/ContestTopicComponent';
import TestInfo from './ContestTestInfo';
import GetTest from './ContestGetTest';
import TestTakingModalComponent from '../plp/TestTakingModalComponent';
import Loader from 'react-loader-spinner';
import TimerComp from '../../views/contest/ContestTimerComp';
import HmEventRegistry from './../../model/HmEventRegistry';
import ContestQuesAlert from '../../components/common/ContestQuesAlert';

const loadingView = "loadingView";

class ContestLayout extends ContestLanding {
    constructor(props) {
        super(props);
        this.state = {
          alreadywatched:false,
          dataLoaded:false,
          modalShow:false,
          modalContent:"loading",
          modalTitle:"",
          modalView:"loading",
          timerShow:false,
          elapsedTime:0,
          forceUpdater:0,
          contestpopupShow:false,
          isRecording:false,
          recordingTime:0,
          evidenceClips:[],
          isPostingVideo:false,
          postVideoStatus:null,
          showPostVideoButton:true,
          showVideoButtons:true
      };

      this.accessId = 0;
      this.gradeProductMap = {};

      this.selectedGradeOption = null;
      this.selectedProductOption = null;
      this.comboNamesLoaded = false;
      this.gradeStore = null;
      this.homeDropDownKey = "homeDropdown";
      this.preferredGrade = null;
      this.preferredProduct = null;
      this.TestTypeLbl = "";

      this.showSubscribemodal= this.showSubscribemodal.bind(this);
      this.hideSubscribeModal= this.hideSubscribeModal.bind(this);

 		//this.assignStateFromParent = this.assignStateFromParent.bind(this);
 		//this.showFormobile=this.showFormobile.bind(this);

        //this.goToLanding = this.goToLanding.bind(this);

        this.data = null;
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.startTest = this.startTest.bind(this);
        
        this.onSubTopicChangedEvent = this.onSubTopicChangedEvent.bind(this);
        this.onSubTopicStartPT = this.onSubTopicStartPT.bind(this);
        this.setModalBackdropClose = this.setModalBackdropClose.bind(this);

        this.selectedGradeOption = null;
        this.dashboardDropDownKey = "homeDropdown";
        this.setChild(this,"CONTEST");

        this.closeTimer = this.closeTimer.bind(this);
        this.starttime = 0;
        this.topicInfoObj = {};
        this.getelapsedTime = this.getelapsedTime.bind(this);
        this.updateelapsedTime = this.updateelapsedTime.bind(this);
        this.autoSubmit = this.autoSubmit.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.resumeTimer = this.resumeTimer.bind(this);
        this.pauseTimer = this.pauseTimer.bind(this);
        this.scheduledReloader = null;
        this.testTimedOutClose  = this.testTimedOutClose.bind(this);
        this.triggerQuestAlertWindow = this.triggerQuestAlertWindow.bind(this);
       
        this.contestType ="";
        this.timedOut = 0;
    }

    componentDidMount(){
        super.componentDidMount();
        this.loadLayoutFn();
        //Eligible for last accessView
        this.setLastAccessView();
        HmEventRegistry.fireEvent("INITIATE_GA");
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");

        this.handleRecordingUpdate = (e) => {
            if (e && e.detail) {
                this.setState({
                    isRecording: !!e.detail.isRecording,
                    recordingTime: e.detail.recordingTime || 0
                });
            }
        };
        window.addEventListener('recordingStateUpdate', this.handleRecordingUpdate);

        this.handleEvidenceReady = (e) => {
            if (e && e.detail) {
                console.log("🎬 [ContestLayout] Captured evidence clip for download button:", e.detail);
                this.setState((prevState) => ({
                    evidenceClips: [...(prevState.evidenceClips || []), e.detail]
                }));
            }
        };
        window.addEventListener('contestEvidenceReady', this.handleEvidenceReady);

        this.handleVideoSubmitCompleted = (e) => {
            const isSuccess = e && e.detail && e.detail.status === 'success';
            this.setState({
                isPostingVideo: false,
                postVideoStatus: isSuccess ? 'success' : 'error'
            });
            setTimeout(() => {
                this.setState({ postVideoStatus: null });
            }, 4000);
        };
        window.addEventListener('contestVideoSubmitCompleted', this.handleVideoSubmitCompleted);

        const updateLayoutSettings = (cfg) => {
            if (!cfg) return;
            this.setState({
                showPostVideoButton: cfg.showPostVideoButton !== undefined ? !!cfg.showPostVideoButton : true,
                showVideoButtons: cfg.showVideoButtons !== undefined ? !!cfg.showVideoButtons : true
            });
        };

        if (window.PROCTOR_SETTINGS) {
            updateLayoutSettings(window.PROCTOR_SETTINGS);
        } else {
            fetch('/settings.json')
                .then(res => res.ok ? res.json() : {})
                .then(data => {
                    const cfg = (data && data.proctoring) ? data.proctoring : (data || {});
                    window.PROCTOR_SETTINGS = Object.assign({}, window.PROCTOR_SETTINGS || {}, cfg);
                    updateLayoutSettings(cfg);
                })
                .catch(() => {});
        }
    }

    componentWillUnmount(){
        this.clearTimeOutFn();
        this.clearSchedule(this.scheduledReloader);
        if (this.handleRecordingUpdate) {
            window.removeEventListener('recordingStateUpdate', this.handleRecordingUpdate);
        }
        if (this.handleEvidenceReady) {
            window.removeEventListener('contestEvidenceReady', this.handleEvidenceReady);
        }
        if (this.handleVideoSubmitCompleted) {
            window.removeEventListener('contestVideoSubmitCompleted', this.handleVideoSubmitCompleted);
        }
    }

    handlePostVideoClick(e) {
        if (e && e.stopPropagation) e.stopPropagation();
        if (this.state.isPostingVideo) return;
        this.setState({ isPostingVideo: true, postVideoStatus: null });
        console.log("📤 [ContestLayout] Dispatching manual video submit event ('contestTriggerVideoSubmit')...");
        window.dispatchEvent(new CustomEvent('contestTriggerVideoSubmit', { detail: { isManualTest: true } }));
    }

    downloadEvidenceClip(clip, e) {
        if (e && e.stopPropagation) e.stopPropagation();
        if (!clip || !clip.blob) return;
        const blobUrl = URL.createObjectURL(clip.blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = `Evidence_Video_${clip.index || 1}_${clip.alertMeta ? clip.alertMeta.alertType : 'ALERT'}.webm`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
    }

    formatTime(seconds){
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return (mins < 10 ? '0' : '') + mins + ':' + (secs < 10 ? '0' : '') + secs;
    }

    clearTimeOutFn(){
        //console.log("timedOut clearTimeOutFn ");
        if(typeof this.timedOut === "number"){
            clearTimeout(this.timedOut);
        }
    }

    testTimedOutClose(testStartTime,testEndTime){
        //console.log("timedOut testTimedOutClose ",testStartTime," : ",testEndTime);
        let me = this;
        let currentDate = Math.round((new Date().getTime()) / 1000);
        if(currentDate > testStartTime){
            let timedOutVal = (!isNaN(testEndTime) && (testEndTime > currentDate)) ? (testEndTime - currentDate) : 5000;
            this.timedOut = setTimeout(() => {
                //me.hideModal("testtimedout");
            },(timedOutVal * 1000));
            console.warn("timedOut test",(timedOutVal * 1000));
        }       
      }

    loadLayoutFn(){
        var me = this;
        var success = function(response){
            if(response!=null){
             me.data = response;
             //console.warn("response ",response);
             me.setState({dataLoaded:true,forceUpdater: (me.state.forceUpdater++)});
             me.scheduleReload(me.data.tests);
             me.triggerQuestAlertWindow(me.data.tests);
         }
     } 

     var failure = function(err){

     }

    if(!this.state.dataLoaded){
        new HmAjax(this.getUrlFor("CONTEST").replace("{#contestId}",this.getContestHost())).get(success, failure);
    }else{
        new HmAjax(this.getUrlFor("CONTEST").replace("{#contestId}",this.getContestHost())).mask().get(success, failure);
    }     
 }


 componentWillUnmount(){
    this.clearSchedule(this.scheduledReloader);
}


clearSchedule(obj){
    if(typeof obj === "number"){
        clearTimeout(obj);
    }
}

   /**
   * This method will check
   *
   */
   scheduleReload(testData){
    const me = this;    
    try{        
        if(testData && testData.length > 0){
            let dateArr = [];
            let currTime = Math.round(new Date().getTime() / 1000);

            for(let i=0; i < testData.length; i++){
                if(!isNaN(testData[i].startTime) && testData[i].startTime > currTime){
                    dateArr.push(testData[i].startTime);
                }

                if(!isNaN(testData[i].endTime) && testData[i].endTime > currTime){
                    if(!isNaN(testData[i].durationInSeconds)){
                        dateArr.push((testData[i].endTime - testData[i].durationInSeconds));
                    }else{
                        dateArr.push(testData[i].endTime);    
                    }                    
                }
            }

            if(dateArr.length > 0){
                dateArr.sort();

                let diffTime = (dateArr[0]- currTime) + 2;
                console.warn("User Test Reload scheduled for '"+diffTime+"' secs");
                if(diffTime > 0 && !me.scheduled){
                    this.scheduled = true;
                    me.scheduledReloader =  setTimeout(() =>{                  
                        console.warn("Reload User Test triggered");  
                        me.loadLayoutFn();
                    }, (diffTime * 1000));                    
                }                
            }
        }
    }catch(e){
        console.err(e);
    }        
}


onSubTopicStartPT(){	 
        //this.props.callbackParent(this.subtopic,"PT");
    }  


    startTest(topicInfoObj){
        var me=this;
        let durationInSeconds = false;
        if(topicInfoObj){
            durationInSeconds =  topicInfoObj.duration > 0 ? true : false;
        }

        this.setState({  modalContent:this.loadTestScreen(topicInfoObj), modalTitle:this.setModalTitle(topicInfoObj), modalView:"testView",timerShow:durationInSeconds});

        if(topicInfoObj){
            try{
                me.starttime = topicInfoObj.duration;
                me.topicInfoObj = topicInfoObj;
                me.setState({elapsedTime:me.topicInfoObj.userDuration})
                me.clearTimeOutFn();
            }catch(e){
                console.log("timer not saved");
            }
        }

        // let source_test_id = 0;
		// 	let resumed = null;
		// 	if(topicInfoObj.testDetails.mode == 1 || topicInfoObj.testDetails.mode == "1"){
		// 		source_test_id = null;

		// 		if(this.state.selectedSubTopic.status == "NEW"){
		// 			resumed = false;
		// 		}
		// 		else if(this.state.selectedSubTopic.status == "IN_PROGRESS"){
		// 			resumed = true;
		// 		}

		// 	}else{
		// 		source_test_id = this.state.selectedSubTopic.testId;

		// 		if(this.state.selectedSubTopic.reqTestStatus == "NEW"){
		// 			resumed = false;
		// 		}
		// 		else if(this.state.selectedSubTopic.reqTestStatus == "IN_PROGRESS"){
		// 			resumed = true;
		// 		}

		// 	}




			// var trackObj = {
			// 	"subtopic_id" : topicsubtopicId,
			// 	"test_id": topicInfoObj.testDetails.id,
			// 	"source_test_id": source_test_id,
			// 	"resumed": resumed
			// }
			//this.initiateTrack("test_started",trackObj);
        }

        closeTimer(){
            //console.log("closeTimer", this.refs.TimerComp);
            if(ReactDOM.findDOMNode(this.refs.TimerComp)){
                if(typeof this.refs.TimerComp.stopTimer === "function"){
                    this.refs.TimerComp.stopTimer();
                }				
            }

        /*if(this.timerComp && typeof this.timerComp.stopTimer === "function"){
            this.timerComp.stopTimer();
        }*/

        this.setState({timerShow:false});
    }

    pauseTimer(){
        if(ReactDOM.findDOMNode(this.refs.TimerComp)){
            if(typeof this.refs.TimerComp.pauseTimer === "function"){
                this.refs.TimerComp.pauseTimer();
            }				
        }

    /*	if(this.timerComp && typeof this.timerComp.pauseTimer === "function"){
            this.timerComp.pauseTimer();
        }*/

        this.setState({timerShow:true});
    }

    resumeTimer(){
        if(ReactDOM.findDOMNode(this.refs.TimerComp)){
            if(typeof this.refs.TimerComp.resumeTimer === "function"){
                this.refs.TimerComp.resumeTimer();
            }				
        }

        /*if(this.timerComp && typeof this.timerComp.resumeTimer === "function"){
            this.timerComp.resumeTimer();
        }*/

        this.setState({timerShow:true});
    }

    startTimer(){
        if(ReactDOM.findDOMNode(this.refs.TimerComp)){
            if(typeof this.refs.TimerComp.startTimer === "function"){
                this.refs.TimerComp.startTimer();
            }				
        }

        /*if(this.timerComp && typeof this.timerComp.startTimer === "function"){
            this.timerComp.startTimer();
        }*/

        this.setState({timerShow:true});
    }

    autoSubmit(){
        if(this.getTestComponent && typeof this.getTestComponent.submitClick === "function"){
            this.getTestComponent.submitClick(true);
        }
    }

    getelapsedTime(){
      return this.state.elapsedTime;
  }

  updateelapsedTime(time){
      this.setState({elapsedTime:time})
  }

  showModal(contestId,roundTestId,testStatus){	
    this.setState({ modalShow: true, modalContent:this.setTestInfoScreen(contestId,roundTestId,testStatus), modalTitle:"", modalView:"testInfo" });
  }	

  triggerQuestAlertWindow(testData){
    //console.log("lalalala ::", testData);
    /**
    * mock - mock test, round1 - live test
    */
    const contest_types = ["mock", "round1"];
    let currentContestType = contest_types[0];
    let showAlert = false;
    const currTime = Math.round(new Date().getTime() / 1000);
    testData.map((elem, index) => {
            if(elem && ((elem.startTime < currTime && elem.endTime > currTime) || elem.testAvailable)){
                showAlert = true;
                // one-time check to give priority to benchmark test
                if(elem.benchmarkAvailable){
                    currentContestType = contest_types[1];
                }
            }
    })
    	
    let questionViewedAttr = this.getAttribute("cntalert_"+currentContestType) || false;
    let allowTestFromHome = window.allowTestFromHome[this.getSelectedContestGroup()] || false;
    if(!questionViewedAttr && !allowTestFromHome && showAlert){
        this.questionPromptWindow(currentContestType);
    }
  }

  questionPromptWindow(contestType){
    let me=this;
    this.contestType = contestType;
    me.setState({contestpopupShow:true})
    //HmEventRegistry.fireEvent("CONTEST_QUESTIONALERT",obj);
  }

  setTestInfoScreen(contestId,roundTestId,testStatus){
      return <TestInfo close={this.hideModal} callbackParent={this.startTest} testTimedOutClose={this.testTimedOutClose} UserTestStatus={testStatus} roundTestId={roundTestId} contestId={contestId} onRef={ref => (this.getTestInfoComponent = ref)}/>
  }
  loadTestScreen(topicInfoObj){		
   return <GetTest topicInfoObj={topicInfoObj} onRef={ref => (this.getTestComponent = ref)} gradeName={"contest"} subtopic={this.state.selectedSubTopic} callbackParent={this.getelapsedTime}  startTimer={this.startTimer} resumeTimer={this.resumeTimer} pauseTimer={this.pauseTimer} closeTimer={this.closeTimer}/>
}

hideModal(callFrom = "close"){
    let me = this;

    let callBack = () => {
        me.clearTimeOutFn();
        me.closeTimer();
        me.onCloseHandler();

        me.getTestComponent = null
        me.getTestInfoComponent = null;

        me.setState({ modalShow: false, modalContent:"loading", view:loadingView, modalTitle:"", modalView:"loading" });
        //me.getTopicList(subTopicView);
        if(callFrom==="testtimedout"){
            console.log("testtimedout");
           // me.showAlert(' ',me.rb("test.locked"));
        }
        me.loadLayoutFn();
    }

    try{			
        if(this.getTestComponent){
            /**
            * IMPORTANT: Closing timer via callback handler to avoid any 
            * unprecedented events
            */
            //this.closeTimer();            
            this.getTestComponent.modalCloseEvent(callBack);            
        }else if(this.getTestInfoComponent){
            this.getTestInfoComponent.trackTestClose();

            callBack();
        }
    }catch(e){
        callBack();
    }
}


hideSubscribeModal(){
  this.setState({SubscribeModal:false});
}

onCloseHandler(){
    try{
        if(this.getTestComponent && typeof this.getTestComponent.onCloseHandler === "function"){
            this.getTestComponent.onCloseHandler();
        }else{
            console.warn("Not submitting this test: function 'onCloseHandler' not available");
        }					
    }catch(e){
        console.error(e);
    }
}


showSubscribemodal(){
  this.setState({SubscribeModal:true});
}

onSubTopicChangedEvent(testDetails){	
        //console.warn("testDetails ",testDetails);
		// var testId = subtopicMap.testId;
        var testStatus = testDetails.userTestDetails.status || "UN_ATTEMPTED";
        var contestId = testDetails.contestId;
        var roundTestId = testDetails.roundTestId;

		// var recommendtestid = subtopicMap.recommendtestid;
		// var reqTestStatus = subtopicMap.reqTestStatus;

		// var selectedtopicsubtopicId = subtopicMap.topicsubtopicId;
		// var selectedrevisiontestid = subtopicMap.revisiontestid;
		
		// this.TestTypeLbl = typelbl;
		
		// this.setState({selectedSubTopic:subtopicMap});
		
		
        if(testStatus.toUpperCase() == "COMPLETED"){
            if(contestId == 0 || contestId == null){				
                alert("show revision scorecared for testId="+contestId);
            }else if(testStatus == "COMPLETED"){	
                alert("show recommendation scorecared for testId="+contestId);
            }else{				
                //alert("start Practice for recommendtestid="+recommendtestid);
                this.showTestModal(contestId,roundTestId,testStatus);
                //this.showAccessCodeModal(contestId,roundTestId,testStatus);
            }
        }else{			
            this.showTestModal(contestId,roundTestId,testStatus);
            //this.showAccessCodeModal(contestId,roundTestId,testStatus);
        }
    }

    showTestModal = (contestId,roundTestId,testStatus) => {
        this.clearSchedule(this.scheduledReloader);
        this.showModal(contestId,roundTestId,testStatus);
        this.fireMobileToast();
    }

    showAccessCodeModal = (contestId,roundTestId,testStatus) => {
        this.setState({ modalShow: true, modalContent:this.showAccesModelUI(contestId,roundTestId,testStatus), modalTitle:"", modalView:"accessCode" });
    }

    accessCodeSubmit = (contestId,roundTestId,testStatus) => {
        console.warn("accessCodeSubmit clicked");
        this.showTestModal(contestId,roundTestId,testStatus);
    }

    showAccesModelUI = (contestId,roundTestId,testStatus) => {
        return(
            <div className="accessCodeUI">
                <label>Enter Access Code : <input></input></label>
                <div>
                <button type="button" className="btn btn-primary mediumBtn float-right mb-20 ml-10" onClick={this.hideModal} > Cancel</button>
                <button type="button" className="btn btn-primary mediumBtn float-right mb-20 ml-10" onClick={this.accessCodeSubmit.bind(this,contestId,roundTestId,testStatus)}>Submit</button>
                </div>
            </div>
        )
    }

    renderContestUI(){
        if(this.state.dataLoaded && this.data != null){
            let data = this.data;
            if(data && data.tests && data.tests.length > 0){
             return Object.values(data.tests).map((contest,index)=>{

                let testAvailable = contest.testAvailable || false
                let lockingReason = contest.lockingReason || "";
                let testLocking  =  (lockingReason === "end_date_in_past") ? false : true;
                let benchmarkAvailable = contest.benchmarkAvailable || false;
                //console.log("testLocked ",testAvailable , " : ",testLocking );
                if(benchmarkAvailable || testAvailable || (testLocking)){
                    return (
                        <ContestTopicComponent callbackParent={this.onSubTopicChangedEvent} key={index} dataIndex={index} topic={contest} ></ContestTopicComponent>
                        )
                    }
                })
            }
        }
    }

    loadModalContent(){
        if (this.state.modalContent === "loading") {
            return(
            <div className="text-center loadingAnim">
            <Loader 
            type="Oval"
            color="#00BFFF"
            height="100"	
            width="100"
            />
            </div>
            )
        }else{
            return(
            <div>
            {this.state.modalContent}						
            </div>
            )
        }

    }

    setModalClass(){
        if(this.state.modalView == "testView"){
            return " modal-lg custom-modal";
        }
        return " modal-lg";
    }

    setModalBackdropClose(){
        if (this.state.modalView == "lessonInfo") {
            return this.hideModal;
        } 
        return undefined;
    }

    setModalTitle(topicInfoObj){
        let testType = "";
        if(topicInfoObj.testMode == 1 || topicInfoObj.testMode == "1"){
            testType = " - "+ this.rb("home.proficiencytest");
        }else{
            testType = " - "+ this.rb("home.practicetest");
        }
        let topics = "Contest" ;//topicInfoObj.testDetails.topics.split("- Customized Practice").join("- Customised Practice");	
        //console.log("topicinfo ",topicInfoObj);
        return topicInfoObj.title; //topics + testType;
    }

    contestPopup(){
        let me=this;
        if(this.state.contestpopupShow){
            let contestType = this.contestType;
            var callBack = function(){
                me.setAttribute("cntalert_"+contestType, true);
                me.setState({contestpopupShow:false});
            }

            return(
                <ContestQuesAlert callBack={callBack} type={contestType}/>
            )
        }
    }

    render(){
        let me=this;
        if(!this.state.dataLoaded){
            return super.render(this.showLoader());
        }else{
            return super.render(
                <div className="HomeComponent" id="contestlayout">
                <div id="pointsContainer" className="homeTopicContainer">
                {this.renderContestUI()}

                <TestTakingModalComponent className="contesttesttaking" visible={this.state.modalShow} dialogClassName={this.setModalClass()} onClickBackdrop={this.setModalBackdropClose()}>
                <div className="modal-header bg-purple d-flex align-items-center justify-content-between">
                <div className="modal-title">
                {this.state.modalTitle}
                </div>
                {(() => {
                  if(this.state.timerShow){
                    let testDetails={};
                    testDetails["contestId"]=this.topicInfoObj.contestId;
                    testDetails["roundTestId"]=this.topicInfoObj.roundTestId;
                    testDetails["userTestId"]=this.topicInfoObj.userTestId;
                    return (
                    <TimerComp onShow={true} ref='TimerComp' autoSubmit={this.autoSubmit} starttime={this.starttime - this.topicInfoObj.userDuration} testDetails={testDetails} elapsedTime={this.topicInfoObj.userDuration} callbackParent={this.updateelapsedTime} endTime={this.topicInfoObj.endTime} duration={this.topicInfoObj.duration}></TimerComp>
                    )
                }
            })()}

            <div className="d-flex align-items-center ml-auto mr-3">
                {this.state.showPostVideoButton !== false && (
                    <button
                        type="button"
                        onClick={(e) => this.handlePostVideoClick(e)}
                        disabled={this.state.isPostingVideo}
                        title="Trigger the video submit API called during test submission"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            backgroundColor: this.state.postVideoStatus === 'success' ? '#10b981' : (this.state.postVideoStatus === 'error' ? '#ef4444' : '#f59e0b'),
                            color: '#ffffff',
                            border: 'none',
                            padding: '6px 12px',
                            borderRadius: '14px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            marginRight: '8px',
                            cursor: this.state.isPostingVideo ? 'not-allowed' : 'pointer',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                            transition: 'all 0.2s ease',
                            opacity: this.state.isPostingVideo ? 0.7 : 1
                        }}
                    >
                        <span>
                            {this.state.isPostingVideo ? 'Posting...' : (this.state.postVideoStatus === 'success' ? 'Video Posted!' : 'Post Video')}
                        </span>
                    </button>
                )}

                {this.state.showVideoButtons !== false && this.state.evidenceClips && this.state.evidenceClips.map((clip, idx) => {
                    const durMin = clip.totalDurationSeconds 
                        ? (clip.totalDurationSeconds / 60).toFixed(1) 
                        : '0.0';
                    return (
                        <button
                            key={'evidence-btn-' + idx}
                            type="button"
                            onClick={(e) => this.downloadEvidenceClip(clip, e)}
                            title={`Click to download Video ${clip.index || (idx + 1)} (${clip.totalDurationSeconds ? clip.totalDurationSeconds.toFixed(0) + 's' : 'Evidence'})`}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                backgroundColor: '#10b981',
                                color: '#ffffff',
                                border: 'none',
                                padding: '6px 12px',
                                borderRadius: '14px',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                marginRight: '8px',
                                cursor: 'pointer',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                                transition: 'all 0.2s ease'
                            }}
                        >
                            <span>Video {clip.index || (idx + 1)} [{durMin}]</span>
                        </button>
                    );
                })}

                {this.state.isRecording && (
                    <div className="screen-recording-badge header-recording-badge" style={{ display: 'inline-flex', alignItems: 'center', backgroundColor: '#ffffff', color: '#dc3545', border: '1px solid #dc3545', padding: '3px 10px', borderRadius: '15px', fontSize: '12px', fontWeight: 'bold', boxShadow: '0 2px 6px rgba(0,0,0,0.15)', zIndex: 1000 }}>
                        <span className="recording-pulsing-dot" style={{ width: '8px', height: '8px', backgroundColor: '#dc3545', borderRadius: '50%', marginRight: '6px' }}></span>
                        <span className="recording-label" style={{ marginRight: '6px' }}>REC LIVE</span>
                        <span className="recording-timer" style={{ fontFamily: 'monospace', fontSize: '13px', color: '#bd2130', background: 'transparent' }}>{this.formatTime(this.state.recordingTime)}</span>
                    </div>
                )}
            </div>
            <div className="close" onClick={this.hideModal} aria-label="Close">  
        {/* data-ga={"Post login - "+this.selectedGradeOption.label+" - "+this.getProductIndication()+" - "+this.state.selectedTopic.topicName+" - "+this.state.selectedSubTopic.subTopicName+" - "+this.getTestTypeLbl()} */}
        <span aria-hidden="true"><i className="material-icons">close</i></span>
        </div>
        </div>
        <div className="modal-body testModalBody">
        {this.loadModalContent()}
        </div>							
        </TestTakingModalComponent>

        
        </div>
        {
           this.contestPopup()
        }
        </div>
        )
    }


}
}

export default ContestLayout;


// WEBPACK FOOTER //
// ./src/views/contest/ContestLayout.js